import { render, staticRenderFns } from "./metric.vue?vue&type=template&id=4955bcbf&"
import script from "./metric.vue?vue&type=script&lang=js&"
export * from "./metric.vue?vue&type=script&lang=js&"
import style0 from "./metric.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports